import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core"
import React from "react"
import { colors } from "../../utils/theme"
import CloseIcon from "../atoms/CloseIcon"
import InsightDetail from "./InsightDetail"

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: theme.spacing(2),
  },
  title: {
    padding: theme.spacing(4, 4, 2),
  },
  contentRoot: {
    padding: theme.spacing(1, 4, 4),
  },
  tabButton: {
    backgroundColor: colors.primary.ice_03,
    opacity: 1,
    color: colors.primary.midnight,
    textTransform: "capitalize",
    minHeight: 50,
    "&.Mui-selected": {
      backgroundColor: colors.primary.ice,
    },
    "&:first-child": {
      borderTopLeftRadius: 100,
      borderBottomLeftRadius: 100,
    },
    "&:last-child": {
      borderTopRightRadius: 100,
      borderBottomRightRadius: 100,
    },
    "&.MuiTab-root": {
      minWidth: "unset",
    },
  },
  tabPanel: {
    display: "grid",
    gap: theme.spacing(3),
    padding: theme.spacing(3, 0),
  },
  domainLabel: {
    display: "flex",
    justifyContent: "center",
  },
  domainDot: {
    height: 10,
    width: 10,
    margin: 8,
    borderRadius: 20,
    display: "inline-block",
  },
  cancelContainer: {
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pickerContainer: {
    border: `1px solid ${colors.neutral.clay}`,
    borderRadius: 12,
    padding: theme.spacing(5, 3, 4),
    position: "relative",
    margin: theme.spacing(3, 3, 0, 3),
    display: "grid",
    gap: theme.spacing(4),
  },
  pickerTabsContainer: {
    // width offset for pickerContainer margin
    width: `calc(100% - ${theme.spacing(6)}px)`,
    position: "absolute",
    left: theme.spacing(3),
    top: -30,
    border: `4px solid ${colors.neutral.white}`,
    borderRadius: 150,
    backgroundColor: colors.neutral.white,
  },
  pickerBody: {
    display: "grid",
    gap: theme.spacing(4),
  },
  dayPicker: {
    paddingTop: theme.spacing(2),
    display: "grid",
    gridAutoFlow: "column",
    gridAutoColumns: "1fr",
  },
  dayCheckbox: {
    borderColor: colors.neutral.clay,
    borderWidth: 1,
    borderStyle: "solid",
    borderLeftWidth: 0,
    borderRadius: 0,
    "&:first-child": {
      borderLeftWidth: 1,
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    "&:last-child": {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },

    "&:hover": {
      backgroundColor: colors.primary.ice_03,
    },
    "&.Mui-checked": {
      backgroundColor: colors.primary.ice,
    },
    "&.Mui-checked:hover": {
      backgroundColor: colors.primary.periwinkle,
    },
    "&:active": {
      backgroundColor: colors.primary.periwinkle,
    },
    "&.Mui-focusVisible": {
      border: `2px solid ${colors.primary.periwinkle}`,
    },
  },
  dayCheckboxLabel: {
    color: colors.primary.shadow,
    fontWeight: "bold",
  },
  focusVisible: {
    "&.Mui-focusVisible": {
      boxShadow: `0 0 0 2px ${colors.primary.periwinkle}`,
    },
  },
}))

interface UserInsightsDialogProps extends DialogProps {
  insightId: number
}

export const UserInsightsDialog: React.FC<UserInsightsDialogProps> = ({
  insightId,
  ...props
}) => {
  const classes = useStyles()

  return (
    <>
      <Dialog {...props} fullWidth maxWidth="md">
        {/* Sort of a hack, but I have to give the `onClose` arguments to work :shrug: */}
        <IconButton
          className={classes.closeButton}
          onClick={(e) => {
            props.onClose?.(e, "backdropClick")
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle disableTypography className={classes.title}>
          <Typography variant="h3" component="h2">
            Insights
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.contentRoot}>
          <InsightDetail insightPK={insightId} />
        </DialogContent>
      </Dialog>
    </>
  )
}
